const { Core, Events } = Global;

customElements.define('vehicle-dropdown', class extends Core {

    render() {
        this.$({ change: this._changeHanler});
        this.sectionID = this.getAttribute("data-section-id");
        this.jsonData = JSON.parse(this.querySelector(".vehicle-menu-data").innerHTML);
        this.linkButton = this.querySelector(".vehicle-selector-item-dropdown a");
        this.select_1 = this.querySelector("[name=vehicle_dropdown-1]");
        this.select_2 = this.querySelector("[name=vehicle_dropdown-2]");
        this.select_3 = this.querySelector("[name=vehicle_dropdown-3]");

        // NEW: Pre-select logic
        this.defaultMake = this.getAttribute("data-default-make");
        if (this.defaultMake && this.select_1) {
            this.select_1.value = this.defaultMake;
            // Manually trigger the change handler for the first dropdown to populate the second dropdown
            this._changeHanler({ target: this.select_1 });
        }
    }

    _changeHanler(event) {
      var dropdownIndex = event.target.getAttribute("name").split("-")[1];
      if(dropdownIndex == "1" || dropdownIndex == "2"){
        this.linkButton.setAttribute("disabled","disabled");
        this.linkButton.setAttribute("href","#");
      }else if(dropdownIndex == "3"){
        this.linkButton.removeAttribute("disabled");
        this.linkButton.setAttribute("href",this.select_3.value);
      }
      if(dropdownIndex == "1"){
        var select1Value = this.select_1.value;
        var dropdownContent = {};
        this.jsonData.forEach(function(item,index){
          if(Object.keys(item)[0] == select1Value){
            dropdownContent = item[select1Value];
          }
        });
        this._rebuildDropdown(dropdownContent,this.select_2, 2);
      }else if(dropdownIndex == "2"){
        var select1Value = this.select_1.value;
        var select2Value = this.select_2.value;
        var dropdownContent;
        this.jsonData.forEach(function(item,index){
          if(Object.keys(item)[0] == select1Value){
            var firstDropdownContent = item[select1Value];

            firstDropdownContent.forEach((item_2,index) => {
              if(Object.keys(item_2)[0] == select2Value){
                dropdownContent = item_2[select2Value];
              }
            });
          }
        });
        this._rebuildDropdown(dropdownContent,this.select_3, 3);
      }
      
    }

    _rebuildDropdown(dropdownContent, select, selectIndex){
      var optionsArr = [];
      var listBox = select.closest("drop-down").querySelector("[data-element=listbox]");
      var selectedListBoxValue = select.closest("drop-down").querySelector("[data-element=selected-value]");
      listBox.innerHTML = "";
      select.innerHTML = "";
      selectedListBoxValue.innerHTML="";
      var listBoxOptions = document.createElement("div"); 
      listBoxOptions.setAttribute("data-options",""); 
      listBoxOptions.classList.add("#product-options-dropdown-options"); 
       var option = document.createElement("option"); 
        option.value = "";
        option.innerText = "";
        option.setAttribute("selected","");
        option.setAttribute("disabled","");
        select.appendChild(option);

      if(selectIndex == 2){
        var anotherlistBox = this.select_3.closest("drop-down").querySelector("[data-element=listbox]");
        var anotherSelectedListBoxValue = this.select_3.closest("drop-down").querySelector("[data-element=selected-value]");
        anotherlistBox.innerHTML = "";
        this.select_3.innerHTML = "";
        anotherSelectedListBoxValue.innerHTML="";
        var option = document.createElement("option"); 
        option.value = "";
        option.innerText = "";
        option.setAttribute("selected","");
        option.setAttribute("disabled","");
        this.select_3.appendChild(option);
      }
      
      dropdownContent.forEach((item,index) => {
         var optionValue = Object.keys(item)[0];
         if(selectIndex == 3){
          var linkValue = item[Object.keys(item)[0]];
         }
         var option = document.createElement("option"); 
         if(selectIndex == 3){
          option.value = linkValue;
         }else{
         option.value = optionValue;
         }
         option.innerText = optionValue;
         select.appendChild(option);

         var listBoxOption = document.createElement("div"); 
         listBoxOption.classList.add("#product-options-dropdown-options-item"); 
 
         var input = document.createElement("input"); 
         var label = document.createElement("label"); 
        
         var inputID = this._handleizeStr(optionValue) + "-vehicle-dropdown-" + selectIndex+ "-" + this.sectionID;
         var inputName = "vehicle-dropdown-" + selectIndex + "-" + this.sectionID;

         input.setAttribute("type","radio");
         input.setAttribute("name",inputName);
         input.setAttribute("id",inputID);
         input.setAttribute("hidden","");
         input.setAttribute("data-dropdown-option","");
         if(selectIndex == 3){
           input.value = linkValue;
         }else{
           input.value = optionValue;
         }
         

         label.setAttribute("for",inputID);
         label.classList.add("#product-options-dropdown-options-item-title");
         label.innerText = optionValue;

         listBoxOption.appendChild(input);
         listBoxOption.appendChild(label);
         listBoxOptions.appendChild(listBoxOption);
         
        });

       listBox.appendChild(listBoxOptions);
    }

  _handleizeStr(str) {
      return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  }
})